import "./app.css";
import App from "./App.svelte";
import { sentry } from "./services/index";

sentry.init();

const app = new App({
  target: document.getElementById("app"),
});

export default app;
